
import Layout from '../components/Layout';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Award, Briefcase, Clock, Compass, Headphones, Heart, Rocket, Users, Building, Star, BookOpen, Flag } from 'lucide-react';
import { Link } from 'react-router-dom';

const benefits = [
  {
    icon: Compass,
    title: "Remote-First",
    description: "Work from anywhere in the world. We believe in hiring the best talent, regardless of location."
  },
  {
    icon: Clock,
    title: "Flexible Hours",
    description: "Choose when you work best. We focus on results, not when you achieve them."
  },
  {
    icon: Heart,
    title: "Health & Wellness",
    description: "Comprehensive health insurance and wellness programs to keep you at your best."
  },
  {
    icon: Rocket,
    title: "Career Growth",
    description: "Continuous learning opportunities and clear career progression paths."
  },
  {
    icon: Users,
    title: "Amazing Team",
    description: "Work with passionate individuals who inspire and support each other."
  },
  {
    icon: Headphones,
    title: "Latest Tech",
    description: "Access to cutting-edge tools and technologies to do your best work."
  }
];

const values = [
  {
    icon: Star,
    title: "Excellence",
    description: "We strive for excellence in everything we do, pushing boundaries and setting new standards."
  },
  {
    icon: Building,
    title: "Innovation",
    description: "We embrace creativity and innovative thinking to solve complex challenges."
  },
  {
    icon: BookOpen,
    title: "Learning",
    description: "We foster a culture of continuous learning and knowledge sharing."
  },
  {
    icon: Flag,
    title: "Impact",
    description: "We make meaningful contributions that positively impact millions of users."
  }
];

const Career = () => {
  return (
    <Layout>
      <div className="py-20">
        <div className="container-custom">
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-5xl font-bold mb-6 dark:text-white">
              Join the Fembot Team
            </h1>
            <p className="text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto mb-8">
              Help us build the future of Discord bots and community engagement. We're looking for passionate individuals who want to make a difference.
            </p>
            <Link to="/open-positions">
              <Button size="lg" className="gradient-pink">
                <Briefcase className="mr-2" />
                View Open Positions
              </Button>
            </Link>
          </div>

          <div className="mb-20">
            <h2 className="text-3xl font-bold text-center mb-12 dark:text-white">Why Join Us?</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {benefits.map((benefit, index) => (
                <Card key={index} className="p-6 hover:shadow-lg transition-all duration-300 hover:-translate-y-1">
                  <div className="flex items-center mb-4">
                    <div className="p-2 rounded-lg bg-fembot-pink/10">
                      <benefit.icon className="h-6 w-6 text-fembot-pink" />
                    </div>
                    <h3 className="text-xl font-bold ml-3 dark:text-white">{benefit.title}</h3>
                  </div>
                  <p className="text-gray-600 dark:text-gray-300">{benefit.description}</p>
                </Card>
              ))}
            </div>
          </div>

          <div className="mb-20">
            <h2 className="text-3xl font-bold text-center mb-12 dark:text-white">Our Values</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
              {values.map((value, index) => (
                <Card key={index} className="p-6 hover:shadow-lg transition-all duration-300 hover:-translate-y-1">
                  <div className="flex items-center mb-4">
                    <div className="p-2 rounded-lg bg-fembot-pink/10">
                      <value.icon className="h-6 w-6 text-fembot-pink" />
                    </div>
                    <h3 className="text-xl font-bold ml-3 dark:text-white">{value.title}</h3>
                  </div>
                  <p className="text-gray-600 dark:text-gray-300">{value.description}</p>
                </Card>
              ))}
            </div>
          </div>

          <div className="text-center">
            <h2 className="text-3xl font-bold mb-6 dark:text-white">Ready to Join Us?</h2>
            <p className="text-xl text-gray-600 dark:text-gray-300 max-w-2xl mx-auto mb-8">
              Explore our open positions and find your perfect role in our growing team.
            </p>
            <Link to="/open-positions">
              <Button size="lg" className="gradient-pink">
                <Briefcase className="mr-2" />
                View Open Positions
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Career;
